export type WatermarkInput = {
  email?: string | null;
  viewId?: string | null;
  timestamp?: string | null;
};

/** Forensic watermark line: email · timestamp · view ID */
export function buildWatermarkText(input: WatermarkInput): string {
  const parts: string[] = [];
  if (input.email) parts.push(String(input.email));
  if (input.timestamp) parts.push(String(input.timestamp));
  if (input.viewId) parts.push(String(input.viewId));
  return parts.join(" · ");
}
